import React, { useState } from 'react';
import axios from 'axios';
import Swal from "sweetalert2";
import ObtieneDatosCookies from '../tools/obtieneDatosCookiesUsuario';

const GenerarPaseDeSalida = ({ datos, onClose }) => {

    const Usuario = ObtieneDatosCookies();
// console.log(datos)
    // Estado para controlar si una petición está en curso
    const [isLoading, setIsLoading] = useState(false); 

    // Función auxiliar para formatear fechas
    const formatISOToLocal = (isoString) => {
        if (!isoString) return "";
        const date = new Date(isoString);
        // Ajusta a la zona horaria local para que datetime-local muestre la hora correcta
        return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
            .toISOString()
            .slice(0, 16);
    };
// console.log(datos)
    const [formData, setFormData] = useState({
        fechaHoraSalida: formatISOToLocal(datos?.fechaHoraSalida),
        fechaHoraRegreso: formatISOToLocal(datos?.fechaHoraRegreso),
        cadeteDni: datos?.cadeteDni || "",
        promocionId: datos?.cadetePromocion, // Esto parece ser un valor fijo, considera si siempre es 1.
        dependenciaAutorizanteId: Usuario.destino,
        usuarioAutorizanteId: Usuario.identificacion,
        sede: Usuario.sedeID == 2 ? "Rosario" : "Recreo",
        tipo: datos?.tipo || "",
        observacion: "",
        estado: "Pendiente",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevFormData) => {
            let newFormData = { ...prevFormData, [name]: value };

            if (name === "fechaHoraSalida") {
                const salida = new Date(value);
                const regreso = new Date(prevFormData.fechaHoraRegreso);

                // Si la fecha de regreso no es válida o es anterior/igual a la salida, ajustarla
                if (!prevFormData.fechaHoraRegreso || regreso <= salida) {
                    salida.setHours(salida.getHours() + 1); // Añadir 1 hora por defecto
                    newFormData.fechaHoraRegreso = salida.toISOString().slice(0, 16);
                }
            }
            return newFormData;
        });
    };

    // Maneja el envío del formulario
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Si ya hay una petición en curso, no hacer nada
        if (isLoading) {
            return;
        }

        // Validar que la fecha de regreso sea posterior a la de salida
        const salida = new Date(formData.fechaHoraSalida);
        const regreso = new Date(formData.fechaHoraRegreso);

        if (regreso <= salida) {
            Swal.fire({
                title: "Error en las fechas",
                text: "La fecha y hora de regreso debe ser posterior a la de salida.",
                icon: "error",
                confirmButtonText: "OK",
            });
            return; // Detiene la ejecución si la validación falla
        }

        // Activar el estado de carga
        setIsLoading(true);

        try {
            // Codifica en Base64
            const token = btoa(`${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`);
            // Crea el cliente axios
//             console.log(formData)
            const client = axios.create({
                baseURL: `${process.env.REACT_APP_BASEURL}NCadetes/creaPaseDeSalida/`,
                headers: {
                    Authorization: `Basic ${token}`,
                },
            });

            const response = await client.post('/', formData);

            if (response.data.success) {
                if (datos.carpetaMedicaId) {
//                     console.log(datos.carpetaMedicaId, response.data);
                    const username = process.env.REACT_APP_KEY;
                    const password = process.env.REACT_APP_PASS;
                    const tokenActualiza = btoa(`${username}:${password}`); // Renombrado para claridad

                    const actualizaSanidad = await axios.post(
                        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaCarpetaMedica/${datos.carpetaMedicaId}`,
                        { paseDeSalidaId: response.data.nuevoPaseDeSalida.id },
                        {
                            headers: {
                                Authorization: `Basic ${tokenActualiza}`,
                            },
                        }
                    );

                    if (actualizaSanidad) { // Verifica si la petición de actualización fue exitosa
                        Swal.fire({
                            title: "Pase de Salida Generado con Éxito",
                            text: "Se generó un pase de salida para el cadete " + formData.cadeteDni,
                            icon: "success",
                            confirmButtonText: "OK",
                        }).then(() => onClose());
                    }
                } else {
                    Swal.fire({
                        title: "Pase de Salida Generado con Éxito",
                        text: "Se generó un pase de salida para el cadete " + formData.cadeteDni,
                        icon: "success",
                        confirmButtonText: "OK",
                    }).then(() => onClose());
                }
            } else {
                Swal.fire({
                    title: response.data.message,
                    text: "Compruebe el pase de salida activo de este cadete: " + formData.cadeteDni,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }

        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "Fallo la generación, compruebe si el cadete existe o si hay un problema de red.",
                icon: "error",
                confirmButtonText: "OK",
            });
            console.error('Error al enviar los datos:', error); // Usar console.error para errores
        } finally {
            // Desactivar el estado de carga siempre, sin importar el resultado
            setIsLoading(false);
        }
    };

    return (
        <div style={{ height: "405px", width: "450px%", overflow: "auto", margin: "0 auto" }}>
            <form onSubmit={handleSubmit}>
                <div className="" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <div className="col-md-6">
                        <label htmlFor="fechaHoraSalida" className="form-label">Fecha y Hora de Salida</label>
                        <input
                            type="datetime-local"
                            className="form-control"
                            id="fechaHoraSalida"
                            name="fechaHoraSalida"
                            value={formData.fechaHoraSalida}
                            onChange={handleChange}
                            // Restringe el input a no poder seleccionar fechas futuras
                            // new Date().toISOString().slice(0, 16) obtiene la fecha y hora actual en formato ISO 8601
                            max={new Date(new Date().setHours(23, 59, 59, 999) - 3 * 60 * 60 * 1000).toISOString().slice(0, 16)} 
                            required
                        />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="fechaHoraRegreso" className="form-label">Fecha y Hora de Regreso</label>
                        <input
                            type="datetime-local"
                            className="form-control"
                            id="fechaHoraRegreso"
                            name="fechaHoraRegreso"
                            value={formData.fechaHoraRegreso}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="cadeteDni" className="form-label">Cadete DNI</label>
                        <input
                            type="number"
                            className="form-control"
                            id="cadeteDni"
                            name="cadeteDni"
                            value={formData.cadeteDni}
                            onChange={handleChange}
                            required
                            disabled // El DNI está deshabilitado, presumiblemente viene de `datos`
                        />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="tipo" className="form-label">Tipo de Pase</label>
                        <select
                            className="form-select"
                            id="tipo"
                            name="tipo"
                            value={formData.tipo}
                            onChange={handleChange}
                            required
                        >
                            <option value={""}>--Seleccionar</option>
                            <option value={"Sanidad"}>Sanidad</option>
                            <option value={"Franco de Honor"}>Franco de Honor</option>
                            <option value={"Tramites Administrativos"}>Tramites Administrativos</option>
                            <option value={"Permiso Especial"}>Permiso Especial</option>
                            <option value={"Servicio Externo"}>Servicio Externo</option>
                            <option value={"Otro"}>Otro</option>
                        </select>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="observacion" className="form-label">Observación</label>
                        <input
                            type="text"
                            className="form-control"
                            id="observacion"
                            name="observacion"
                            value={formData.observacion}
                            onChange={handleChange}
                            placeholder="Observación (opcional)"
                        />
                    </div>
                </div>

                {/* Botones del formulario */}
                <button type="submit" className="btn btn-primary w-80" disabled={isLoading}>
                    {isLoading ? 'Creando Pase...' : 'Crear Pase de Salida'}
                </button>
                <button onClick={() => onClose()} className="btn btn-danger w-20" disabled={isLoading}>
                    Cancelar
                </button>
            </form>
        </div>
    );
};

export default GenerarPaseDeSalida;
